const planSlider = () => {
  const sliderMain = document.querySelectorAll('.plan-details__main-slider-img');
  const sliderImg = document.querySelectorAll('.plan-details__main-slider-item');
  const sliderArrowLeft = document.querySelectorAll('.plan-details__main-slider-arrow')[0]
  const sliderArrowRight = document.querySelectorAll('.plan-details__main-slider-arrow')[1]
  let sliderCount = 0

  if(sliderArrowRight != undefined) {
    sliderArrowRight.onclick = () => {
      if(sliderCount < sliderMain.length - 1) {
        sliderMain[sliderCount].classList.remove('plan-details__main-slider-img--active')
        sliderCount++
        sliderMain[sliderCount].classList.add('plan-details__main-slider-img--active')
      } else {
        sliderCount = 0
        sliderMain[sliderCount].classList.add('plan-details__main-slider-img--active')
        sliderMain[sliderMain.length - 1].classList.remove('plan-details__main-slider-img--active')
      }
    }
  }

  if(sliderArrowLeft) {
    sliderArrowLeft.onclick = () => {
      if(sliderCount > 0) {
        sliderMain[sliderCount].classList.remove('plan-details__main-slider-img--active')
        sliderCount--
        sliderMain[sliderCount].classList.add('plan-details__main-slider-img--active')
      } else {
        sliderCount = sliderMain.length - 1
        sliderMain[sliderCount].classList.add('plan-details__main-slider-img--active')
        sliderMain[0].classList.remove('plan-details__main-slider-img--active')
      }
    }
  }

  for(let x = 0; x < sliderImg.length; x++) {
    if(sliderImg[x] != undefined) {
      sliderImg[x].addEventListener('click', () => {
        for(let y = 0; y < sliderImg.length; y++) {
          sliderMain[y].classList.remove('plan-details__main-slider-img--active');
        }
        sliderMain[x].classList.add('plan-details__main-slider-img--active');
        sliderCount = x;
      })
    }
  }
}

export default planSlider